import { calculateInvestmentAndSubsidy } from "../../../config/incentiveClaimFormUtils";
import { recommenedInvestment } from "../../../forms/incentiveClaimApplicationFields";
import { stringEquals } from "../../../utils/utils";

const EditableInvestmentInput = ({
  keyLabel,
  formData,
  setFormData,
  wordValue,
  language = false,
}) => {
  const isCapitalSubsidy = stringEquals(
    keyLabel,
    language
      ? recommenedInvestment.capitalSubsidy.label.hi
      : recommenedInvestment.capitalSubsidy.label.en,
  );

  const fieldName = isCapitalSubsidy
    ? recommenedInvestment.capitalSubsidy.name
    : Object.values(recommenedInvestment).find((item) =>
        language ? item.label.hi : item.label.en === keyLabel,
      )?.name;

  const handleChange = (e) => {
    const inputValue = e.target.value;

    // allow only numbers + decimal
    if (inputValue !== "" && !/^\d*\.?\d*$/.test(inputValue)) return;

    const updatedFormData = {
      ...formData,
      [fieldName]: inputValue,
    };

    // Capital subsidy affects dependent calculations
    if (isCapitalSubsidy) {
      const { updated } = calculateInvestmentAndSubsidy(updatedFormData);
      setFormData(updated);
    } else {
      setFormData(updatedFormData);
    }
  };

  return (
    <div>
      <input
        type="text"
        value={formData[fieldName] || ""}
        onChange={handleChange}
        className="border rounded px-2 py-1 w-1/2"
      />

      {wordValue && (
        <p className="text-sm text-theme-color mt-1">
          {language ? wordValue.hi : wordValue.en}
        </p>
      )}

      {/* Capital Subsidy Validations */}
      {isCapitalSubsidy && formData.recommended_investment && (
        <>
          {parseFloat(formData.recommended_investment) >
            parseFloat(
              formData.total_eligible_investment_after_non_eligible_deduction,
            ) && (
            <p className="text-red-500 text-sm mt-1">
              Value must not exceed Total Eligible Investment (
              {formData.total_eligible_investment_after_non_eligible_deduction})
            </p>
          )}

          {parseFloat(formData.recommended_investment) < 10000000 && (
            <p className="text-red-500 text-sm mt-1">
              {language
                ? "मूल्य कम से कम 1 करोड़ होना चाहिए"
                : "Value must be at least 1 Crore"}
            </p>
          )}
        </>
      )}

      {/* Stamp Duty Validation */}
      {!isCapitalSubsidy &&
        formData.stamp_duty_recommended_investment &&
        parseFloat(formData.stamp_duty_recommended_investment) >
          parseFloat(formData.total_stamp_duty_per_year) && (
          <p className="text-red-500 text-sm mt-1">
            {language
              ? "मूल्य प्रति वर्ष कुल स्टांप शुल्क से अधिक नहीं होना चाहिए।"
              : "Value must not exceed Total Stamp Duty Per Year"}{" "}
            ({formData.total_stamp_duty_per_year})
          </p>
        )}
    </div>
  );
};

export default EditableInvestmentInput;
